(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[376],{

/***/ 8278:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/news/[slug]",
      function () {
        return __webpack_require__(3021);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 5467:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ HeroSubpage; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5893);
/* harmony import */ var _photo__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(4761);


function HeroSubpage(props) {
    var ref;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("section", {
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
            className: "header-subpage relative ".concat(props.headerCss ? props.headerCss : ""),
            children: [
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                    className: "relative subpage-gradient w-full",
                    children: ((ref = props.image) === null || ref === void 0 ? void 0 : ref.data) ? props.imageAsBackground ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                className: "absolute z-1 top-0 w-full h-full opacity-50 bg-blend-soft-light bg-no-repeat bg-cover bg-center",
                                style: {
                                    backgroundImage: "url(".concat(props.image.data.attributes.url, ")")
                                }
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                className: "container py-[12rem] relative z-2 ",
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                    className: "flex items-center justify-start ",
                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                        className: "flex flex-col w-full p-10 md:w-2/3 text-white justify-start ".concat(props.contentCss ? props.contentCss : ""),
                                        dangerouslySetInnerHTML: {
                                            __html: props.content
                                        }
                                    })
                                })
                            })
                        ]
                    }) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                        className: "container",
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                            className: "flex items-center justify-start py-[10rem]",
                            children: [
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                    className: "flex w-2/5 mx-auto md:w-1/2 relative z-20 pl-8 justify-center",
                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_photo__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z, {
                                        image: props.image
                                    })
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                    className: "flex flex-col w-full p-8 pt-0 md:w-2/3 text-white justify-start",
                                    dangerouslySetInnerHTML: {
                                        __html: props.content
                                    }
                                })
                            ]
                        })
                    }) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                        className: "container",
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                            className: "flex items-center justify-start pt-[6rem] pb-[6rem]",
                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                className: "flex flex-col w-full p-10 ".concat(!props.full ? "md:w-2/3" : "", " text-white justify-start"),
                                dangerouslySetInnerHTML: {
                                    __html: props.content
                                }
                            })
                        })
                    })
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                    className: "skew-bottom"
                })
            ]
        })
    });
}


/***/ }),

/***/ 604:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ PhotoGallery; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(7294);
/* harmony import */ var _photo__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(4761);
/* harmony import */ var fslightbox_react__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(1129);
/* harmony import */ var fslightbox_react__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(fslightbox_react__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var next_image__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(5675);
/* harmony import */ var next_image__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(next_image__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var _lib_global_context__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(5439);
/* harmony import */ var _section_title__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(5715);
/* harmony import */ var _lib_media__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(6017);








function PhotoGallery(props) {
    var ref = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(false), toggler = ref[0], setToggler = ref[1];
    var ref1 = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(1), slide = ref1[0], setSlide = ref1[1];
    var ref2 = (0,_lib_global_context__WEBPACK_IMPORTED_MODULE_5__/* .useGlobalContext */ .bN)(), state = ref2.state, dispatch = ref2.dispatch;
    var photos = props.photos.data.map(function(p) {
        return p.attributes.mime === "video/mp4" ? {
            type: "video",
            src: p.attributes.url,
            caption: p.attributes.caption,
            thumb: ""
        } : {
            type: "image",
            width: p.attributes.width,
            height: p.attributes.height,
            image: {
                data: p
            },
            src: p.attributes.url,
            thumb: p.attributes.formats.thumbnail.url,
            caption: p.attributes.caption
        };
    });
    var limit = props.visibleSlides || photos.length;
    var gallery = photos.slice(0, limit);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
        children: [
            (props.title || props.desciption) && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_section_title__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z, {
                title: props.title,
                description: props.description,
                className: "w-full md:w-1/2"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                className: "gallery relative ".concat(props.type ? props.type : "", " ").concat(props.className ? props.className : "", " ").concat(gallery.length === 1 ? "cols-1" : ""),
                children: gallery.map(function(p, index) {
                    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                        "data-id": index,
                        className: "relative w-full aspect-[4/3]",
                        onClick: function() {
                            setSlide(index + 1);
                            setToggler(!toggler);
                        },
                        children: [
                            p.type === "image" && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_image__WEBPACK_IMPORTED_MODULE_4___default()), {
                                src: (0,_lib_media__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)(p.image),
                                alt: p.image.data.attributes.alternativeText || "",
                                layout: "fill",
                                priority: !index ? true : false,
                                quality: 85,
                                className: "object-cover"
                            }),
                            p.type === "video" && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("video", {
                                muted: false,
                                autoPlay: true,
                                playsInline: true,
                                src: p.src
                            }),
                            p.type === "video" && gallery.length && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("button", {
                                type: "button",
                                className: "absolute top-[calc(50%-2.5rem)] text-[5rem] left-[calc(50%-2.5rem)] text-white",
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("i", {
                                    className: "flaticon-youtube"
                                })
                            })
                        ]
                    }, "slide-".concat(index));
                })
            }),
            gallery.length < photos.length && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                className: "continue relative w-full h-full justify-center items-center flex",
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("button", {
                    className: "btn maturity-border",
                    onClick: function() {
                        return setToggler(!toggler);
                    },
                    children: "View all photos"
                })
            }, "slide-last"),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((fslightbox_react__WEBPACK_IMPORTED_MODULE_3___default()), {
                showThumbsOnMount: true,
                toggler: toggler,
                sources: photos.map(function(p) {
                    return p.src;
                }),
                types: photos.map(function(p) {
                    return p.type;
                }),
                thumbs: photos.map(function(p) {
                    return p.thumb;
                }),
                captions: photos.map(function(p) {
                    return p.caption;
                }),
                slide: slide,
                onOpen: function() {
                    return dispatch({
                        type: "GALLERY",
                        payload: true
                    });
                },
                onClose: function() {
                    return dispatch({
                        type: "GALLERY",
                        payload: false
                    });
                }
            })
        ]
    });
}


/***/ }),

/***/ 5715:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ SectionTitle; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5893);

function SectionTitle(param) {
    var title = param.title, description = param.description, style = param.style, className = param.className;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
        className: "".concat(className, " flex flex-col px-10 relative z-20  section-title"),
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                className: "flex flex-row section-title-wrapper",
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("i", {
                        className: "".concat(style ? style : "", " flaticon-down-arrow text-5xl opacity-50 flex mr-2")
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                        className: "".concat(style ? style : "", " mr-2 uppercase"),
                        dangerouslySetInnerHTML: {
                            __html: title
                        }
                    })
                ]
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                className: "full mt-2 text-normal",
                dangerouslySetInnerHTML: {
                    __html: description
                }
            })
        ]
    });
}


/***/ }),

/***/ 4994:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "$U": function() { return /* binding */ Merge; }
/* harmony export */ });
/* unused harmony exports estimateTime, formatDate, uniqueArray, sortObjectByKey, getFirstLastName, replaceValuesInString, setEmailVars, nextGivenDay */
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(6042);
/* harmony import */ var _swc_helpers_src_type_of_mjs__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(2222);



function Merge(glob, page) {
    var newObj = (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)({}, glob);
    for(var key in page){
        if (typeof page[key] === "object") {
            if (key === "metaImage") {
                if (page[key].data !== null) {
                    newObj[key] = page[key];
                }
            } else if (key === "metaSocial") {
                if (page[key].length > 0) {
                    newObj[key] = page[key];
                }
            } else {
                newObj[key] = page[key];
            }
        } else if ((0,_swc_helpers_src_type_of_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(page[key]) === "array") {
            if (page[key].length) {
                newObj[key] = page[key];
            }
        } else {
            if (page[key]) {
                newObj[key] = page[key];
            }
        }
    }
    return newObj;
}
var estimateTime = function(content) {
    var text = content.replace(/(<([^>]+)>)/gi, "");
    var words = text.split(" ");
    return Math.ceil(words.length / 200);
};
var formatDate = function(date) {
    var newDate = new Date(date);
    return newDate.toLocaleDateString("en-US", {
        weekday: "short",
        year: "numeric",
        month: "short",
        day: "numeric"
    });
};
var uniqueArray = function(arrayData) {
    return arrayData.filter(function(value, index, self) {
        return self.indexOf(value) === index;
    });
};
var sortObjectByKey = function(list, key) {
    var subKey = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : null, order = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : "asc";
    if (subKey) {
        if (order === "asc") {
            return list.sort(function(a, b) {
                return a[key][subKey] > b[key][subKey] ? 1 : b[key][subKey] > a[key][subKey] ? -1 : 0;
            });
        } else {
            return list.sort(function(a, b) {
                return a[key][subKey] < b[key][subKey] ? 1 : b[key][subKey] < a[key][subKey] ? -1 : 0;
            });
        }
    } else {
        if (order === "asc") {
            return list.sort(function(a, b) {
                return a[key] > b[key] ? 1 : b[key] > a[key] ? -1 : 0;
            });
        } else {
            return list.sort(function(a, b) {
                return a[key] < b[key] ? 1 : b[key] < a[key] ? -1 : 0;
            });
        }
    }
};
var getFirstLastName = function() {
    var fullName = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : "";
    var name = fullName.trim();
    if (!name.length) {
        return {
            firstname: "",
            lastname: ""
        };
    }
    var splitName = name.split(" ");
    var firstName = splitName[0];
    var lastName = splitName.length > 1 ? splitName[splitName.length - 1] : "";
    return {
        firstname: firstName,
        lastname: lastName
    };
};
var defaultReplaceMap = {
    "[[[": "{{{",
    "]]]": "}}}",
    "[[": "{{",
    "]]": "}}"
};
var replaceValuesInString = function(str) {
    var replaceMap = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : defaultReplaceMap;
    var pattern, replacer;
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    try {
        for(var _iterator = Object.entries(replaceMap)[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
            var _value = _sliced_to_array(_step.value, 2), key = _value[0], value = _value[1];
            pattern = new RegExp(key.replace(/[.*+?^${}()|[\]\\]/g, "\\$&"), "g");
            replacer = value;
            str = str.replace(pattern, replacer);
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator.return != null) {
                _iterator.return();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
    return str;
};
var setEmailVars = function(text) {
    return text.replace(/\[\[\[/g, "{{{").replace(/\]\]\]/g, "}}}").replace(/\[\[/g, "{{").replace(/\]\]/g, "}}");
};
var nextGivenDay = function(day, hour) {
    var toISO = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : true;
    var daysOfWeek = [
        "Sunday",
        "Monday",
        "Tuesday",
        "Wednesday",
        "Thursday",
        "Friday",
        "Saturday"
    ];
    var today = new Date();
    var targetDay = today.getDay();
    while(daysOfWeek[targetDay] !== day){
        targetDay = (targetDay + 1) % 7;
    }
    var nextDate = new Date(today.getFullYear(), today.getMonth(), today.getDate() + (targetDay + 7 - today.getDay()) % 7);
    nextDate.setHours(hour);
    if (nextDate <= today) {
        nextDate.setDate(nextDate.getDate() + 7);
    }
    if (toISO) {
        return nextDate.toISOString();
    } else {
        nextDate;
    }
};


/***/ }),

/***/ 3021:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "__N_SSG": function() { return /* binding */ __N_SSG; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5893);
/* harmony import */ var _lib_seo_context__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(4449);
/* harmony import */ var next_image__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(5675);
/* harmony import */ var next_image__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(next_image__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var _components_layout__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(5726);
/* harmony import */ var _components_hero_subpage__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(5467);
/* harmony import */ var _components_photo_gallery__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(604);
/* harmony import */ var _lib_helper__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(4994);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(1664);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_7___default = /*#__PURE__*/__webpack_require__.n(next_link__WEBPACK_IMPORTED_MODULE_7__);
/* harmony import */ var _lib_global_context__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(5439);









var Event = function(props) {
    var state = (0,_lib_global_context__WEBPACK_IMPORTED_MODULE_8__/* .useGlobalContext */ .bN)().state;
    var pageProps = props.pageProps, global = props.global;
    if (!pageProps) {
        return "";
    }
    var seo = (0,_lib_helper__WEBPACK_IMPORTED_MODULE_6__/* .Merge */ .$U)(global === null || global === void 0 ? void 0 : global.seo, pageProps === null || pageProps === void 0 ? void 0 : pageProps.seo);
    seo.canonicalURL = "".concat("https://www.arka-parcel-lockers.com", "/news/").concat(pageProps.slug);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_lib_seo_context__WEBPACK_IMPORTED_MODULE_1__/* ["default"].Provider */ .Z.Provider, {
        value: seo,
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_layout__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
            languageData: {
                originalSlug: pageProps.originalSlug,
                languages: pageProps.localizations
            },
            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("section", {
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_hero_subpage__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, {
                        content: "<h1>".concat(pageProps.title, "</h1>")
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("article", {
                        className: state.galleryStatus ? "" : "z-20 relative",
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                            className: "container p-10 pt-0",
                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                className: "flex flex-col md:flex-row",
                                children: [
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                        className: "flex flex-col pr-0 lg:pr-8",
                                        children: [
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                                className: "relative w-full rounded-lg overflow-hidden",
                                                children: pageProps.gallery.data > 0 && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_photo_gallery__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z, {
                                                    layout: "fill",
                                                    className: "cols-1",
                                                    photos: {
                                                        data: [
                                                            pageProps.gallery.data[0]
                                                        ]
                                                    }
                                                })
                                            }),
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                                className: "mt-2",
                                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                                    className: " bg-maturity-100 px-2 py-1 text-xs rounded-md inline-block",
                                                    children: new Date(pageProps.date).toDateString()
                                                })
                                            }),
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                                className: "pt-2",
                                                dangerouslySetInnerHTML: {
                                                    __html: pageProps.content
                                                }
                                            }),
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                                className: "py-10",
                                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_7___default()), {
                                                    href: "/news",
                                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("a", {
                                                        className: "btn maturity-border",
                                                        children: "Back to news"
                                                    })
                                                })
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                        className: "flex flex-col flex-wrap flex-shrink-0  basis-1 lg:basis-1/3 ",
                                        children: pageProps.gallery.data && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_photo_gallery__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z, {
                                            layout: "fill",
                                            className: "cols-".concat(pageProps.gallery.data.length > 2 ? 2 : 1),
                                            photos: {
                                                data: pageProps.gallery.data.slice(1)
                                            }
                                        })
                                    })
                                ]
                            })
                        })
                    })
                ]
            })
        })
    });
};
var __N_SSG = true;
/* harmony default export */ __webpack_exports__["default"] = (Event);


/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [396,535,726,774,888,179], function() { return __webpack_exec__(8278); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);